export function Case1({onNext}) {
    const handleSubmit = (e) => {
        e.preventDefault();
        onNext();
    };

    return (

        <div className="texte">
            <div className="centered">
                <h5><b>Bienvenue dans l'espace</b></h5>
                <h5><b>« Etude devis suite à panne »</b></h5>
            </div>
            <span>
                Cliquez sur « SUIVANT » afin de nous fournir
            </span>
            <span>
                les éléments nécessaires à l'instruction de votre dossier.
            </span>
            <div className="app-buttons">
                <button className="buttons-primaire" onClick={handleSubmit}>Suivant</button>
            </div>
        </div>
    );
}
